import { format } from 'date-fns';
import { isAddressFilled } from 'helpers/addressValidation';
import { Doctor, DoctorAddress } from 'types/doctor';

// O que a API recebe ao gravar o médico: endereço só quando preenchido e data no formato do banco.
export function buildDoctorPayload(doctor: Doctor, address: DoctorAddress | null) {
  return {
    ...doctor,
    address:
      address && isAddressFilled(address)
        ? {
            id: address.id,
            doctor_id: doctor.id,
            zip_code: address.zip_code,
            street: address.street,
            neighborhood: address.neighborhood,
            city: address.city,
            state: address.state,
            street_number: address.street_number,
            complement: address.complement,
          }
        : null,
    birth_date: doctor.birth_date ? format(doctor.birth_date, 'yyyy-MM-dd HH:mm:ss') : '',
  };
}
